import { FC, ReactNode } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import {
  Close as CloseIcon,
  OpenInNew as OpenInNewIcon,
} from "@material-ui/icons";

const useStyles = makeStyles({
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

interface CustomDialogProps {
  children: ReactNode;
  onClose?: () => void;
  openInNew?: () => void;
  title?: string;
}

const CustomDialog: FC<CustomDialogProps> = ({
  children = null,
  onClose,
  openInNew,
  title,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Dialog
      open
      scroll="paper"
      disableEnforceFocus
      maxWidth="md"
      fullWidth
      onClose={handleClose}
    >
      <DialogTitle disableTypography className={classes.modalTitle}>
        <Typography variant="h6" color="primary">
          {title}
        </Typography>
        <Box>
          {openInNew && (
            <IconButton
              size="small"
              onClick={() => {
                openInNew();
                handleClose();
              }}
              aria-label="open-in-new-tab"
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          )}
          <IconButton size="small" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      {children}
    </Dialog>
  );
};

export default CustomDialog;
